import { CONSTANT } from "@/helpers/constant";
import { isJerseyConfiguratorActive } from "@/helpers/common"

const salesforce = ({ to, authedUser, salesChannel }: MiddlewareContext) => {
  const isSalesRep = (authedUser?.customFields?.eecom_tp_is_sales_rep || authedUser?.customFields?.eecom_tp_is_super_sales_rep) || false
  const isEnabledJerseyConfiguratorTool = salesChannel?.translated?.customFields?.eecom_tp_enable_jersey_configurator_tools || false
  const isJerseyConfiguratorActive = authedUser?.customFields?.eecom_tp_is_jersey_configurator || false

  if(!isSalesRep && to.path.startsWith(CONSTANT.ROUTE.PATH.DASHBOARD_SALES_FORCE)){
    return false;
  }

  if((!isEnabledJerseyConfiguratorTool || !isJerseyConfiguratorActive) && to.path.startsWith(CONSTANT.ROUTE.PATH.DASHBOARD_SALES_FORCE_JERSEY_CONFIGURATOR)){
    return false;
  }
  return true
}

export default salesforce
